var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_175",
    "data-name": "Grupo 175",
    transform: "translate(5828 -8235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "maps_ugc_black_24dp",
    transform: "translate(-5828 8235)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1803",
    "data-name": "Rect\\xE1ngulo 1803",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_174",
    "data-name": "Grupo 174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_523",
    "data-name": "Trazado 523",
    d: "M12,4a8,8,0,0,1,0,16,7.925,7.925,0,0,1-3.43-.78,1.963,1.963,0,0,0-.86-.19,2.1,2.1,0,0,0-.56.08l-3.2.94.94-3.2a1.991,1.991,0,0,0-.11-1.42A7.925,7.925,0,0,1,4,12a8.011,8.011,0,0,1,8-8m0-2A10,10,0,0,0,2,12a10.105,10.105,0,0,0,.97,4.29L1,23l6.71-1.97A10.105,10.105,0,0,0,12,22,10,10,0,0,0,12,2Z",
    fill: "#2962ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "phone_black_24dp",
    transform: "translate(-5821.563 8241.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_525",
    "data-name": "Trazado 525",
    d: "M0,0H11.126V11.126H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_526",
    "data-name": "Trazado 526",
    d: "M4.678,6.611A7.023,7.023,0,0,0,7.733,9.666l1.02-1.02a.461.461,0,0,1,.473-.111,5.288,5.288,0,0,0,1.655.264.465.465,0,0,1,.464.464v1.618a.465.465,0,0,1-.464.464A7.88,7.88,0,0,1,3,3.464.465.465,0,0,1,3.464,3H5.086a.465.465,0,0,1,.464.464,5.266,5.266,0,0,0,.264,1.655.465.465,0,0,1-.116.473Z",
    transform: "translate(-1.609 -1.609)",
    fill: "#2962ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWa);
export default __webpack_public_path__ + "static/media/WA.093a7f4f85831c540326ab3a6ecec6ec.svg";
export { ForwardRef as ReactComponent };